import { useEffect, useState } from "react";
import { Tooltip } from "@mui/joy";

// Tap-to-reveal tooltip for the bolão tile icon clusters. MUI Joy's Tooltip is hover/focus only,
// which never fires on touch — so we control `open` from an onClick toggle (mobile-first). The
// opening tap calls stopPropagation so it neither navigates the card (the card root owns onClick)
// nor immediately self-closes; an outside tap — listener attached only while open, in the effect —
// closes it. Escape closes via onClose.
const TapTooltip: React.FC<{
  title: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}> = ({ title, style, children }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [open]);
  return (
    <Tooltip
      title={title}
      open={open}
      onClose={() => setOpen(false)}
      placement="top"
      size="sm"
      arrow
      disableHoverListener
      disableFocusListener
      sx={{ maxWidth: 260 }}
    >
      <span
        style={{ cursor: "pointer", ...style }}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};
export default TapTooltip;
